import React, { useState, useEffect, useReducer } from 'react'
import { Route, Redirect } from 'react-router'
import { Layout } from './components/_reusedcomponents/Layout'
import { Dashboard } from './components/dashboard/DashboardView'
import './App.css'
import { StockContainer } from './components/transactions/articles/StockContainer'
import { IncomingTransactionsContainer } from './components/transactions/incomingtransactions/IncomingTransactionsContainer'
import { AppContext } from "./Context"
import { BaseDataView } from './components/profile/BaseDataView'
import { TransactionArchiveContainer } from './components/transactions/archivedtransactions/TransactionArchiveContainer'
import { LogoutContainer } from './components/authentication/LogoutContainer'
import LoginContainer from './components/authentication/LoginContainer'
import { OutgoingTransactionsContainer } from './components/transactions/outgoingtransactions/OutgoingTransactionsContainer'
import { ArticleTypeContainer } from './components/articletypes/ArticleTypeContainer'
import { CreateTransactionContainer } from './components/transactions/addtransactions/CreateTransactionContainer'
import { MaintainStockContainer } from './components/transactions/addtransactions/MaintainStockContainer'
import { SalesReportContainer } from './components/salesreport/SalesReportContainer'
import { B2COrdersReportContainer } from './components/b2c-orders/B2COrdersReportContainer'
import { FetchBackendPingToPreventTimeout } from './fetcher'

/**
 * Main component for the web client.
 * Connects every component with the according route. Uses private and public routes according to "react-router"
 * sets authenticated and authenticating during login proocess
 * used code snippets from: https://serverless-stack.com/chapters/add-the-session-to-the-state.html for authenticated routing
*/
const App = () => {
    const [isAuthenticated, userHasAuthenticated] = useState(false);
    const [isAuthenticating, setIsAuthenticating] = useState(true);

    const [, forceUpdate] = useReducer(x => x + 1, 0);


    //useEffect hook gets called after the component finished rendering
    //empty array as callback means the effect is called only one time
    useEffect(() => {
        onLoad()
    }, [])

    //used for pinning backend every 12 minutes, to let connection stay open and prevent server timeouts
    useEffect(() => {
        const timer = setInterval(() => FetchBackendPingToPreventTimeout(), 720000)
        return () => clearInterval(timer)
    })

    function onLoad() {
        try {
            sessionStorage.getItem("isAuthenticated") != null && sessionStorage.getItem("isAuthenticated") == "true"
                ? userHasAuthenticated(true) : userHasAuthenticated(false)
        }
        catch (e) {
            if (e !== 'No current user') {
                alert(e)
            }
        }
        setIsAuthenticating(false);
    }

    const changeLanguage = (e) => {
        console.log("ChangeLanguage", e, e.target)
        window.changeLanguage(e.target.dataset.language);
        forceUpdate();
    }

    //private routes are only accessible when logged in
    //routes to the expected component when logged in, redirects to authentication otherwise
    const PrivateRoute = ({ component: Component, ...rest }) => {
        return (
            // Show the component only when the user is logged in
            // Otherwise, redirect the user to /login page
            <Route {...rest} render={props => (
                isAuthenticated ?
                    <Component {...props} />
                    : <Redirect to="/authentication" />
            )} />
        );
    };

    //public routes are accessible for a user who isn't logged in
    //
    const PublicRoute = ({ component: Component, restricted, ...rest }) => {
        return (
            // restricted == false meaning public route
            // restricted == true meaning restricted route (e.g. /login when already authenticated)
            <Route {...rest} render={props => (
                isAuthenticated && restricted ?
                    <Redirect to="/inventory" />
                    : <Component {...props} />
            )} />
        );
    };

    return (
        <div>
            {!isAuthenticating ?
                <AppContext.Provider value={{ isAuthenticated, userHasAuthenticated }}>
                    <Layout changeLanguage={changeLanguage}>
                        <PrivateRoute exact path='/' component={Dashboard} />
                        <PrivateRoute path='/delivery-order' component={CreateTransactionContainer} />
                        <PrivateRoute path='/articles' component={ArticleTypeContainer} />
                        <PrivateRoute path='/inventory' component={StockContainer} />
                        <PrivateRoute path='/maintain-stock' component={MaintainStockContainer} />
                        <PrivateRoute path='/incoming-transactions' component={IncomingTransactionsContainer} />
                        <PrivateRoute path='/outgoing-transactions' component={OutgoingTransactionsContainer} />
                        {/*<PrivateRoute path='/sales' component={Sales} />*/}
                        <PrivateRoute path='/base-data' component={BaseDataView} />
                        <PrivateRoute path='/transaction-archive' component={TransactionArchiveContainer} />
                        <PrivateRoute path='/sales-report' component={SalesReportContainer} />
                        <PrivateRoute path='/b2c-orders' component={B2COrdersReportContainer} />
                        <PrivateRoute path='/logout' component={LogoutContainer} />

                        <PublicRoute path='/authentication' component={LoginContainer} restricted={true} />
                    </Layout>
                    </AppContext.Provider> : null}
        </div>
    );
}

export default App